import React from 'react';
import { useHistory } from 'react-router-dom';

import Button from '../../components/Button';
import IconError from '../../components/Icons/IconError';
import PageHeader from '../../components/PageHeader';

const UnrecoverableErrorPage = () => {
  const history = useHistory();

  return (
    <div className="container container--space-y">
      <PageHeader title="Congrats! You found a bug." />

      <div className="row row--align-middle-small row--align-center">
        <div className="col col--10/16-small">
          <div className="row-spacer">
            Our humblest apologies for this, but you&apos;ve managed to discover a bug in our
            system. We&apos;re currently working on improving our application process and have
            encountered an error we&apos;re still learning about.
          </div>
          <div className="row-spacer">
            If you&apos;re unable to proceed, please get in touch below and describe the steps you
            took to get here. Your input could help countless other students like you.
          </div>
          <div className="row row--align-bottom-small">
            <div className="col col--auto">
              <a
                className="link-button link-button--inverted"
                href={process.env.REACT_APP_GET_IN_TOUCH_URL}
                target="_blank"
                rel="noopener noreferrer"
              >
                Get in touch
              </a>
            </div>
          </div>
          <div className="row-spacer">
            In the meantime, you can return to the previous page to resume your application, or
            continue to apply through our usual application process.
          </div>

          <div className="row row--align-bottom-small">
            <div className="col col--auto">
              <Button theme="ghost" type="button" onClick={() => history.goBack()}>
                Back
              </Button>
            </div>
            <div className="col col--auto">
              <a
                className="link-button"
                href={process.env.REACT_APP_PLATFORM_OLD_APPLICATION_START}
                target="_blank"
                rel="noopener noreferrer"
              >
                Continue
              </a>
            </div>
          </div>
        </div>

        <div className="col col--6/16-small col--4/16-medium col--3/16-large col--align-right-small block--small">
          <IconError />
        </div>
      </div>
    </div>
  );
};

export default UnrecoverableErrorPage;
